<div style="display: flex;align-items: stretch;">
  <p-select [options]="data" [(ngModel)]="value" [disabled]="disabled" dataKey="kod" optionLabel="popis" [inputId]="inputId" [ngClass]="{'header-style': headerStyle, 'body-style': !headerStyle, 'outlined-style': outlinedStyle}"
            placeholder=" " [virtualScroll]="virtualScroll" [virtualScrollItemSize]="38" [filter]="filter" filterBy="popis"></p-select>
</div>
